import styled from 'styled-components';

export const StyledTileContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
`;
export const StyledTile = styled.div<{ isSquare?: boolean; height?: string }>`
  padding: ${({ isSquare }): string =>
    isSquare ? '0 16px 100%' : '20px 16px'};
  width: 100%;
  height: ${({ isSquare, height }): string => (isSquare ? '0' : height)};
  position: relative;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }): string => theme.radii.xl};

  i {
    ${({ isSquare }): string =>
      isSquare
        ? ` position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%)`
        : ''};
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
